import { Chart } from '@frontend/chart/types';

export const LENDING_RETURN_PACKAGE_VOLUME_HOUR_DAY_HEATMAP_CHART_MOCK_DATA: Chart = {
    series: [
        {
            name: 'Returns',
            data: [
                { label: '2026-08-01T16:00:00.000Z', value: 4 },
                { label: '2026-08-02T11:00:00.000Z', value: 6 },
                { label: '2026-08-03T08:00:00.000Z', value: 2 }
            ]
        }
    ]
};
